import React from 'react';
import FormField from '../../../components/forms/FormField';

export default function DadosAmbientais() {
  return (
    <div>
    <div className="mb-6 p-4 bg-blue-50 rounded-lg">
      <p className="text-sm text-blue-700">Esta seção coleta informações sobre aspectos ambientais e iniciativas de sustentabilidade no município.</p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <FormField
        name="areas_urbanas"
        label="Áreas urbanas (%)"
        type="percent"
        placeholder="Digite a porcentagem"
        helpText="Porcentagem do território municipal ocupado por áreas urbanas"
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
          max: {
            value: 100,
            message: 'O valor deve ser menor ou igual a 100',
          },
        }}
      />
      
      <FormField
        name="areas_agricolas"
        label="Áreas agrícolas (%)"
        type="percent"
        placeholder="Digite a porcentagem"
        helpText="Porcentagem do território municipal ocupado por áreas agrícolas"
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
          max: {
            value: 100,
            message: 'O valor deve ser menor ou igual a 100',
          },
        }}
      />
      
      <FormField
        name="areas_preservadas"
        label="Áreas preservadas (%)"
        type="percent"
        placeholder="Digite a porcentagem"
        helpText="Porcentagem do território municipal ocupado por áreas de preservação"
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
          max: {
            value: 100,
            message: 'O valor deve ser menor ou igual a 100',
          },
        }}
      />
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
      <FormField
        name="programa_sustentabilidade"
        label="Nome do programa de sustentabilidade"
        placeholder="Digite o nome do programa"
        helpText="Nome de programa ou iniciativa de sustentabilidade existente"
      />
      
      <FormField
        name="foco_sustentabilidade"
        label="Foco"
        placeholder="Digite o foco do programa"
        helpText="Área de atuação ou objetivo principal"
      />
      
      <FormField
        name="parcerias_sustentabilidade"
        label="Parcerias"
        placeholder="Digite as parcerias existentes"
        helpText="Instituições parceiras na execução do programa"
      />
    </div>
    
    <div className="mt-4">
      <FormField
        name="energia_renovavel"
        label="Uso de energia renovável"
        type="radio"
        options={[
          { value: 'sim', label: 'Sim' },
          { value: 'nao', label: 'Não' },
        ]}
        helpText="Indique se há uso significativo de energia renovável no município"
      />
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <FormField
        name="fonte_energia"
        label="Fonte principal"
        placeholder="Digite a fonte principal de energia renovável"
        helpText="Ex: solar, eólica, biomassa, etc. (se aplicável)"
      />
      
      <FormField
        name="capacidade_instalada"
        label="Capacidade instalada (MW)"
        type="number"
        placeholder="Digite a capacidade em MW"
        helpText="Capacidade instalada em Megawatts (se aplicável)"
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
        }}
      />
    </div>
    <hr className="border-t border-gray-300 my-6" />
    <div className="mt-6 space-y-4">
      <FormField
        name="fontes_principais_secao5"
        label="Fontes principais"
        type="textarea"
        placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
        helpText=""
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
      
      <FormField
        name="links_acesso_secao5"
        label="Links de acesso"
        type="textarea"
        placeholder="Insira os links para acesso às fontes"
        helpText="Informe URLs para acesso às fontes quando disponível"
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
    </div>
  </div>
  );
}
